// Small reusable Chip used for category filters.
// Props:
// - children: label text
// - active: boolean
// - onClick: handler
// - size: "sm" | "md" (controls padding)
// - variant: "chip" (pill) | "list" (full-width list item)
// - className: extra classes
export default function Chip({
    children,
    active,
    onClick,
    size = 'sm',
    variant = 'chip',
    className = '',
    ...rest
}) {
    const base =
        variant === 'list'
            ? 'w-full text-left px-4 py-2 rounded-md transition-colors'
            : 'rounded-full text-xs font-medium transition-colors whitespace-nowrap';

    const sizeClasses =
        variant === 'list' ? '' : size === 'sm' ? 'px-2 py-1' : 'px-3 py-1.5';

    const activeClasses =
        variant === 'list'
            ? 'bg-brand-dark text-white'
            : 'bg-brand-dark text-white border-2 border-brand-dark';

    const inactiveClasses =
        variant === 'list'
            ? 'bg-gray-50 text-gray-700'
            : 'bg-gray-100 text-gray-600 hover:bg-brand/10 hover:text-brand border-2 border-gray-200 hover:border-brand/40';

    const classes = [
        base,
        sizeClasses,
        active ? activeClasses : inactiveClasses,
        'cursor-pointer',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <button
            type="button"
            onClick={onClick}
            className={classes}
            aria-pressed={active}
            {...rest}
        >
            {children}
        </button>
    );
}
